import React, { Component } from 'react';
// requires BS
export default class Modal extends Component {
  static defaultProps = {
    modal_id: null,
    title: null,
    size: null, // null (medium), modal-sm, modal-lg
  }

  header = () => {
    if (this.props.title) {
      return (
        <div className="modal-header">
          <h5 className="modal-title">{this.props.title}</h5>
          {this.close()}
        </div>
      )
    } 
  }

  close = () => (
    <button
    type="button"
    className={`btn-close ${this.props.title ? '' : 'no-title'}`} 
    data-bs-dismiss="modal"
    aria-label="Close"></button>
  )

  render = () => {
    const p = this.props
    return (
      <div className="modal fade light-bg" id={p.modal_id} tabIndex="-1">
        <div className={`modal-dialog ${p.size}`}>
          <div className="modal-content">
            {this.header()}
            <div className="modal-body">
              {p.title ? null : this.close()}
              {p.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
